/** Ответ с байтами: при успехе — данные и полный размер файла, при неудаче — код ошибки стандарта обмена */
export class ApiBytesResponse {
  private success: boolean
  private data: ArrayBuffer | undefined
  private size: number | undefined
  private error: string | undefined

  constructor(response: { success: boolean, data?: ArrayBuffer, size?: number, error?: string }) {
    this.success = response.success
    this.data = response.data
    this.size = response.size
    this.error = response.error
  }

  isSuccess(): boolean {
    return this.success
  }

  getData(): ArrayBuffer {
    if (this.data === undefined) {
      throw new Error('Data is undefined')
    }

    return this.data
  }

  /** Полный размер файла, из которого взяты байты */
  getSize(): number {
    if (this.size === undefined) {
      throw new Error('Size is undefined')
    }

    return this.size
  }

  getError(): string {
    if (this.error === undefined) {
      throw new Error('Error is undefined')
    }

    return this.error
  }
}
